module Client.Admin.UserInfoSections.LoggedInUsers

open Client
open Elmish
open Shared.Admin.UserInfo
open Illy.SafeStack.Client
open Shared
open Fable.React
open Fable.React.Props
open Illy.SafeStack.Client.jQueryUI

type Model =
    {
        Users: UserLoginDetails list
        Loading: bool
    }

type Msg =
    | LoadedUsers of UserLoginDetails list
    | ApiError of ApiError
    | CloseOverlay

type Event =
    | ApiError of ApiError
    | CloseOverlay

let init() =
    {
        Loading = true
        Users = []
    }, Cmd.batch [
        yield Api.secureCall<IUserInfoApi,_,_,_> SecuredRoute.Admin (fun api -> api.loggedInUsers) () LoadedUsers Msg.ApiError
    ]

let update msg model =
    match msg with
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event
    | Msg.ApiError err -> model, err |> ApiError |> SideEffect.Event
    | LoadedUsers users ->
        {
            model with
                Loading = false
                Users = users
        }, SideEffect.none

let view (model: Model) dispatch =
    jQueryUI.modal
        "Logged In Users"
        2500
        Msg.CloseOverlay
        dispatch
        (Some 1000)
        [
            yield jQueryUI.simpleTable 
                "No users found."
                [
                    Some [ str "Username" ] ===> fun (user: UserLoginDetails) -> [ str user.Username ]
                    Some [ str "Date logged in" ] ===> fun (user: UserLoginDetails) -> [ 
                        str (user.LoginDate |> illyDateTime) 
                        str " ("
                        str (Moment.fromNow user.LoginDate)
                        str ")"
                    ]
                    Some [ str "User agent" ] ===> fun (user: UserLoginDetails) -> [ str (UserAgent.unwrap user.UserAgent) ]
                    Some [ str "IP Address" ] ===> fun (user: UserLoginDetails) -> [ str (IPAddress.unwrap user.IPAddress) ]
                ]
                model.Loading
                model.Users
        ]
